module.exports = __webpack_public_path__ + "img/labor-factory-certified.ffa3d588.png";